import styled from 'styled-components';
import { Colors } from '../../shared/colors/colors';
import { Fonts } from '../../shared/fonts/fonts';

export const Label = styled.label<{ fontSize?: number, marginTop?: string }>`
  /* width: 100%; */
  border-collapse: collapse;
  margin: 0;
  margin-left: 5px;
  margin-bottom: 6px;
  margin-top: ${({ marginTop }) => marginTop || 0};
  font-size: ${({ fontSize }) => fontSize || 14}px;
  line-height: 20px;
  letter-spacing: 0.4px;
  font-weight: 600;
  /* text-align: left; */
  color: ${Colors.label};
  font-family: ${Fonts.primary};

`;
